export default __webpack_public_path__ + "static/media/mithali_raj.3dd8da1f.png";